<template>
  <div class="right new-chapter" :style="isShowPop?'height:100vh;overflow:hidden':''">
    <el-form ref="mainInfo" class="chapter-form" :rules="rules" :model="mainInfo"  :inline-message="true">
      <el-form-item prop="chapterTitle" :show-message="false" >
        <el-input v-model="mainInfo.chapterTitle" class="Chapter-title f24 font-PF-R" :placeholder="$lang('authorCenter.stories.newChapterPlace[0]')"></el-input>
      </el-form-item>
      <el-form-item prop="mainCon" :show-message="true" >
        <el-input @input="worknum" class="f18 text-333" v-model="mainInfo.mainCon" type="textarea"></el-input>
      </el-form-item>
      <div class="chapter-btn flexible aItem-center font-MT f16">
        <!--按钮-->
        <div class="flexible flex jc-between-end aItem-center">
          <div><i class="mr10">{{ mainInfo.mainCount }}</i>{{ $lang('authorCenter.stories.words') }}</div>
          <!--保存-->
          <div
          class="f-nto c-btn save-btn flexible aItem-center jc-center"
          v-if="mainInfo.mainCount == 0 || mainInfo.submitType == 'tpublish' ||  mainInfo.submitType == 'publish'"
          >
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[0]') }}
          </div>
          <div
          class="f-csp c-btn c-btn-active save-btn flexible aItem-center jc-center"
          v-else
          @click="saveChapterFun('save')">
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[0]') }}
          </div>
          <!--发布-->
          <div class="f-nto c-btn pub-btn flexible aItem-center jc-center"
               v-if="mainInfo.mainCount == 0"
          >
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[1]') }}
          </div>
          <div class="c-btn f-csp c-btn-active pub-btn flexible aItem-center jc-center"
               v-else
               @click="saveChapterFun('pub')">
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[1]') }}
          </div>
          <!--删除-->
          <div class="f-nto c-btn del-btn flexible aItem-center jc-center"
               v-if="this.$route.params.chapterid == '0' || this.$route.params.chapterid != '0'&&mainInfo.submitType == 'publish'||mainInfo.submitType == 'tpublish'"
          >
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[2]') }}
          </div>
          <div class="c-btn f-csp c-btn-active del-btn flexible aItem-center jc-center"
               v-if="mainInfo.submitType == 'save' && this.$route.params.chapterid != '0'"
               @click="closesure(true)">
            <i class="mr10"></i>
            {{ $lang('authorCenter.stories.newChapterBtn[2]') }}
          </div>
        </div>
      </div>
    </el-form>
    <!--发布弹出框-->
    <surePop v-if="isShowPop" @closesure="closesure">
      <div slot="surecon" class="add-chapter-warp">
        <div class="title flexible aItem-center jc-center f20 text-333 font-MT">
          {{$lang('authorCenter.stories.publishChapter[0]')}}
        </div>
        <el-form class="surecon-detail add-select-publish font-MT f20">
          <el-form-item :label="$lang('authorCenter.stories.publishChapter[1]')">
            <div @click="selectType('publish')" :class="mainInfo.submitType == 'publish'?'el-switch-select':''" class="el-switch">
              <input type="checkbox" name="" true-value="true" class="el-switch__input">
              <span class="el-switch__core">
                 <span class="f16">{{$lang('authorCenter.stories.publishChapter[2]')}}</span>
              </span>
            </div>
            <div class="time-pub-com el-switch" v-if="this.$route.params.chapterid == '0' ||(this.$route.params.chapterid != '0'&&savesubmitType == 'save'||savesubmitType == 'tpublish')" @click="selectType('tpublish')" :class="mainInfo.submitType == 'tpublish'?'el-switch-select':''">
              <input type="checkbox" name="" true-value="true" class="el-switch__input">
              <span class="el-switch__core">
                <span class="f16">{{$lang('authorCenter.stories.publishChapter[3]')}}</span>
              </span>
              <el-date-picker
                      v-model="mainInfo.pubTime"
                      type="datetime"
                      :picker-options="pickerOptions"
                      ref="pubTime"
                      :clearable="true"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="optionbox" class="btn-item flexible jc-center">
        <el-button @click="$event.currentTarget.disabled ? '' : publishChapterFun()" v-preventReClick class="add-btn-confirm f16" size="medium">{{$lang('authorCenter.stories.confirm')}}</el-button>
        <el-button @click="closeFun()" class="el-button-opa f16 cancel-btn" size="medium">{{$lang('authorCenter.stories.cancel')}}</el-button>
      </div>
    </surePop>

   <!--删除弹出框-->
    <surePop v-if="isDel" @closesure="closesure">
      <div slot="surecon">
        <div class="title flexible aItem-center jc-center f20 text-333 font-MT">
          {{$lang('authorCenter.stories.infoTips')}}
        </div>
        <div class="surecon-detail f18 text-333 flexible aItem-center jc-center">
          <div class="text-line36">
            {{$lang('authorCenter.stories.newChapterPlace[6]')}}
          </div>
        </div>
      </div>
      <div slot="optionbox" class="btn-item flexible jc-center">
        <el-button size="medium" class="f16 font-MT ml20" @click="deletebind">{{$lang('authorCenter.stories.confirm')}}</el-button>
        <el-button size="medium" class="el-button-opa f16 font-MT ml24" @click="closesure(false)">{{$lang('authorCenter.stories.cancel')}}</el-button>
      </div>
    </surePop>
  </div>
</template>

<script>
import { isWords } from "utils/core/kernel";
import { publishChapter,delChapter, getEditCon,publishOldChapter } from "apiurl/author";
import { mapState } from "vuex";
export default {
  data() {
    /* 验证内容 */
    var wordsValidator = (rule, value, callback) => {
      if (isWords(value) < 1 || isWords(value) > 3000) {
        callback(new Error(this.$lang('authorCenter.stories.newChapterPlace[1]')));
      } else {
        callback();
      }
    };
    var isnamewords = (rule, value, callback) => {
      if (isWords(value) > 30) {
        callback(new Error(this.$lang('authorCenter.stories.newChapterPlace[2]')));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      savesubmitType: '',
      isShowPop: false,
      mainInfo: {
        mainCount: 0, // 字数
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
        chapterType: false,
        submitType: '',
        pubTime: ""
      },
      rules: {
        chapterTitle: [
          { required: true, message: "", trigger: "change" },
          { validator: isnamewords, trigger: "change" },
        ],
        chapterType: [
          { required: true, message: "", trigger: "change" },
        ],
        mainCon: [
          { required: true, message: "", trigger: "change" },
          {validator: wordsValidator, trigger: "change" }
        ]
      },
      saveChapter: {
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
      },
      // 删除弹窗
      isDel: false,
      // 离开是否需要拦截
      iskeep: false,
    };
  },
  computed: mapState({
    bookname: state => state.author.bookName
  }),
  mounted() {
    let $this = this;
    if ($this.$route.params.chapterid != '0') {
      this.getChapterInfo()
    }
      // else {
    //   this.mainInfo.chapterType = $this.$route.params.allowPrice == 'true'?false:true
    // }
    // window.onbeforeunload = function(e) {
    //   e = e || window.event;
    //   // 兼容IE8和Firefox 4之前的版本
    //   if (
    //           $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
    //           $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
    //           $this.saveChapter.authorCon == $this.mainInfo.authorCon
    //   ) {
    //     //console.log("tag", "可刷新");
    //   } else {
    //     if (e) {
    //       e.returnValue = "关闭提示";
    //     }
    //     // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
    //     return "关闭提示";
    //   }
    // };
  },
  methods: {
    /* ==清空 */
    mainInfoChange() {
      this.mainInfo = {
        mainCount: 0, // 字数
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
        chapterType: false,
        submitType: '',
        pubTime: ""
      }
    },
    async getChapterInfo () {
      let res = await getEditCon({ chapterId: this.$route.params.chapterid });
      if (res.success) {
        // if (res.data.free) {
        //   this.mainInfo.chapterType = true
        // } else {
        //   this.mainInfo.chapterType = false
        // }
        this.mainInfo.chapterTitle = res.data.iname;
        this.mainInfo.mainCon = res.data.icontent;
        this.mainInfo.authorCon = res.data.iadditional;
        this.mainInfo.mainCount = res.data.words;
        if (res.data.isPublish && !res.data.timer) {
          this.mainInfo.submitType = 'publish'
        } else if (!res.data.isPublish && res.data.timer) {
          this.mainInfo.submitType = 'tpublish'
          this.mainInfo.pubTime = res.data.publishTime
        } else {
          this.mainInfo.submitType = 'save'
        }
        this.savesubmitType = this.mainInfo.submitType
      }
    },
    // 保存内容
    saveChapterFun (flag) {
      this.$refs.mainInfo.validate(valid => {
        if (valid) {
          if (this.$route.params.chapterid == '0') {
            if (flag == 'save') {
              this.mainInfo.submitType = 'save'
              this.mainInfo.pubTime = ''
              this.publishChapterFun()
            } else {
              this.isShowPop = true
              this.mainInfo.submitType = 'publish'
              this.$emit('changePop', true)
            }
          } else {
            if (flag == 'save' && this.savesubmitType == 'save' || flag == 'pub' && this.savesubmitType == 'publish') {
              this.publishChapterFun()
            } else {
              this.isShowPop = true
              this.mainInfo.submitType = this.savesubmitType == 'save'?'publish':this.mainInfo.submitType
              this.$emit('changePop', true)
            }
          }
        }
      })
    },
    // 发布新章节
    publishChapterFun() {
      var main = this.mainInfo;
      let data = {
        bookId: this.$route.params.id,
        additional: main.authorCon,
        content: main.mainCon,
        free: main.chapterType,
        name: main.chapterTitle,
        submitType: main.submitType,
        time: main.pubTime
      };
      if (this.$route.params.chapterid == '0') {
        publishChapter(this.qs.stringify(data))
                .then(res => {
                  if (res.success) {
                    // this.iskeep = true
                    this.closeFun()
                    this.$success('add')
                    this.$router.push("/authorManage/chapterList/" + this.$route.params.id);
                    this.$emit('changeChapter', '')
                  }
                })
                .catch(() => {});
      } else {
        data.chapterId = this.$route.params.chapterid
        publishOldChapter(this.qs.stringify(data))
                .then(res => {
                  if (res.success) {
                    this.closeFun()
                    // this.iskeep = true
                    this.$success('edit')
                    this.$router.push("/authorManage/chapterList/" + this.$route.params.id);
                    this.$emit('changeChapter', '')
                  }
                })
                .catch(() => {});
      }

    },
    // 选择发布类型
    selectType (flag) {
      if (flag == 'tpublish') {
        this.$refs.pubTime.focus()
      } else {
        this.mainInfo.pubTime = ''
      }
      this.mainInfo.submitType = flag
    },
    // 关闭弹框
    closeFun () {
      this.isShowPop = false
      this.$emit('changePop', false)
    },
    // 删除章节
    deletebind(value) {
      if (value) {
        delChapter({ chapterId: this.$route.params.chapterid })
                .then(res => {
                  if (res.success) {
                    this.$success('del')
                    this.$router.push("/authorManage/chapterList/" + this.$route.params.id);
                    this.closesure(false)
                  }
                })
                .catch(() => {});
      }
    },
    closesure (data) {
      this.isDel = data
      this.isShowPop = data
      this.$emit('changePop', data)
    },
     //字数
    worknum(){
      this.mainInfo.mainCount = isWords(this.mainInfo.mainCon)
    }
  },
  // beforeRouteLeave(to, from, next) {
    // let $this = this;
    // if ($this.iskeep = true) {
    //   next();
    // } else if (
    //   $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
    //   $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
    //   $this.saveChapter.authorCon == $this.mainInfo.authorCon
    // ) {
    //   next()
    // } else {
    //   let a = window.confirm($this.$lang('create.leavinglost'));
    //   if (a) {
    //     next();
    //   } else {
    //     next(false);
    //   }
    // }
  // },
  beforeDestroy() {
  }
};
</script>
<style lang="scss" scoped>
.new-chapter {
  padding: 40px 40px 0 !important;
  .chapter-form {
    /deep/ .el-input__inner {
      border: none;
      border-bottom: 1px solid #575776;
      color: #fff!important;
      background: #28283D;
    }
    /deep/ .el-textarea__inner {
      background: #28283D;
      border: 1px solid #575776;
      min-height: 700px !important;
      padding: 20px;
      color: #fff;
      line-height: 40px;
    }
    /deep/.el-input__inner::placeholder,
    /deep/.el-textarea__inner::placeholder{
      color: #777796!important;
      font-size: 14px!important;
    }
    /deep/ .el-form {
      width: 100%;
      display: inline-block;
      margin-top: 20px;
    }
    /*.chapter-type {*/
    /*  width: 150px;*/
    /*  /deep/.el-input__inner {*/
    /*    border: 1px solid #CCCCCC;*/
    /*  }*/
    /*}*/
  }
  .chapter-btn {
    width: 100%;
    height: 40px;
    margin-top: 30px;
    color: #fff;
    .c-btn {
      display: block;
      width: 130px;
      height: 40px;
      background: #3B3B51;
      border-radius: 6px;
      margin-left: 30px;
      i {
        display: block;
        width: 18px;
        height: 18px;
      }
      &.c-btn-active{
        background: linear-gradient( 180deg, #8D59F7 0%, #5B57FF 100%, #5A57FF 100%);
      }
      &.save-btn {
        i {
          background: url(../../../assets/author/senLevel/Save.png);
          background-size: 18px 18px;
        }
      }
      &.pub-btn {
        i {
          background: url(../../../assets/author/senLevel/Publish.png);
          background-size: 18px 18px;
        }
      }
      &.del-btn {
        i {
          width: 18px;
          height: 21px;
          background: url(../../../assets/author/senLevel/Delete.png);
          background-size: 18px 21px;
        }
      }
    }
  }
  .add-chapter-warp{
    .add-select-publish{
      .el-form-item{
        margin-bottom: 0;
        margin-top: 59px;
      }
      /deep/.el-form-item__label{
        color: #333;
        font-size: 20px;
        margin-left: 20px;
      }
      /deep/.el-switch__core{
        width: 120px;
        height: 34px;
        border-radius: 17px;
        background: #F2F2F2;
        border-color: #F2F2F2;
        color: #333;
        span{
          line-height: 34px;
          margin-left: 10px;
        }
      }
      /deep/.el-switch__core:after{
        width: 25px;
        height: 25px;
        top: 3px;
        left: 3px;
      }
      .el-switch-select{
        .el-switch__core{
          background: #FF049B;
          color: #fff;
        }
      }
      /deep/.el-input,
      /deep/.el-input__inner{
        border: none;
        width: 165px;
        background: #F8F9FD;
        font-size: 16px;
        padding: 0!important;
        margin-left: 10px;
      }
      /deep/.el-input__prefix,/deep/.el-input__suffix{
        display: none;
      }
    }
  }
  .time-pub-com{
    margin-left: 30px;
  }

}

</style>
